import { createContext, useContext } from 'react';
// 对话相关设置项在此处存
const initContent = {
  msgWithdraw: {
    timeout: 60 * 2,
    status: 'close',
    reviewWithdraw: false
  }
};

export const StreamsSettingContext = createContext(initContent);

const emptyObj = {};

export const useMsgWithdraw = () => {
  const { msgWithdraw } = useContext(StreamsSettingContext);
  return msgWithdraw || emptyObj;
};
